const Icon = ({name= 'wp',outer = 'bg-red-500',inner = 'fill-lime-200'}) => {

    const icons = {
        hero:<g transform="translate(0, 0)">
        <path d="M26,18.3h-5.3l1.5-6.6c0.1-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.5-0.1-0.7,0.1l-7.6,9.6c-0.1,0.2-0.2,0.4-0.1,0.6
            s0.3,0.3,0.5,0.3h5.3l-1.5,6.6c-0.1,0.3,0.1,0.5,0.3,0.6c0.1,0,0.2,0.1,0.2,0.1c0.2,0,0.3-0.1,0.4-0.2l7.6-9.6
            c0.1-0.2,0.2-0.4,0.1-0.6C26.4,18.4,26.2,18.3,26,18.3z"/>
    </g>,
        logo:<g>
        <path d="M34.5,17.3c-0.7,0-1.3,0.6-1.3,1.3v4.4c0,0.5-0.4,0.9-0.9,0.9l0,0h-1l0,0c-0.5,0-0.9-0.4-0.9-0.9v-2.2
            c0-3.2-2.6-5.8-5.8-5.8h-1.2c-3.2,0-5.8,2.6-5.8,5.8l0,2.2c0,0,0,0.1,0,0.1c-0.1,0.4-0.4,0.8-0.9,0.8c-0.5,0-0.9-0.4-0.9-0.9h0
            v-2.2c0-3.2-2.6-5.8-5.8-5.8c0,0-0.2,0-0.3,0c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8l0,0l0,0c0.7,0,1.3-0.6,1.3-1.3
            S10.6,24,9.9,24l0,0l0,0c-1.7,0-3.1-1.4-3.1-3.1l0,0c0-1.7,1.4-3.1,3.1-3.1c0,0,0.2,0,0.3,0c1.7,0,3.1,1.4,3.1,3.1v2.2
            c0,0.1,0,0.1,0,0.2c0.1,1.9,1.7,3.3,3.5,3.3c2,0,3.5-1.6,3.5-3.5l0,0l0-2.2c0-1.7,1.4-3.1,3.1-3.1h1.2c1.7,0,3.1,1.4,3.1,3.1v2.2
            c0,2,1.6,3.5,3.5,3.5l0,0h1.2v0c1.9-0.1,3.4-1.6,3.4-3.5v-4.4C35.9,17.9,35.3,17.3,34.5,17.3z"/>
        <circle cx="34.5" cy="14.7" r="1.3"/>
    </g>,
        leaf:<g>
		<path d="M34.7,5.3C34.5,5.1,34.2,5,33.8,5c-0.6,0.1-15.4,2.6-21.5,8.7c-4.6,4.6-4.5,9.7-3.7,12.9l8.5-5.2L5.3,33.3
			c-0.4,0.4-0.4,1,0,1.4C5.5,34.9,5.7,35,6,35s0.5-0.1,0.7-0.3l4.2-4.2c1.1,0.5,3.2,1.3,5.9,1.3c3.1,0,5.9-1,8.3-3
			c0.4-0.3,0.8-0.7,1.2-1.1c0.3-0.3,0.4-0.7,0.2-1.1l-2.3-5.2l3.9,2.2c0.2,0.1,0.5,0.2,0.8,0.1c0.3-0.1,0.5-0.3,0.6-0.5
			c0.3-0.6,0.6-1.2,0.9-1.9c2.9-6.5,4.6-14.9,4.7-15.2C35,5.9,34.9,5.5,34.7,5.3z"/>
	</g>,
        buy:<g>
            <rect x="8" y="23"  width="24" height="2"/>
	<rect x="10" y="19"  width="6" height="2"/>
	<path  d="M12,12c0,0.6,0.4,1,1,1h14.7l-1.9,7.7l1.9,0.5l2.2-9c0.1-0.3,0-0.6-0.2-0.9S29.3,11,29,11H14V9
		c0-0.6-0.4-1-1-1H8v2h4V12z"/>
	<rect x="12" y="15"  width="6" height="2"/>
	<circle  cx="13.5" cy="29.5" r="2.5"/>
	<circle  cx="28.5" cy="29.5" r="2.5"/>
        </g>,
        cursor:<g>
            <polygon  points="12,15 10,15 10,10 15,10 15,12 12,12 	"/>
            <polygon  points="15,30 10,30 10,25 12,25 12,28 15,28 	"/>
            <polygon  points="30,15 28,15 28,12 25,12 25,10 30,10 	"/>
            <rect x="18" y="10"  width="4" height="2"/>
            <rect x="18" y="28"  width="4" height="2"/>
            <rect x="28" y="18"  width="2" height="4"/>
            <rect x="10" y="18"  width="2" height="4"/>
            <polygon  points="34,26 23,23 26,34 28,30 32,34 34,32 30,28 	"/></g>
        ,
        api:<g>
        <path d="M26,19H10c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1C27,19.4,26.6,19,26,19z"/>
        <path d="M30,19L30,19c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1l0,0c0.6,0,1-0.4,1-1C31,19.4,30.6,19,30,19z"/>
        <path d="M17,15h-7c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h7c0.6,0,1-0.4,1-1C18,15.4,17.6,15,17,15z"/>
        <path d="M30,15h-9c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1C31,15.4,30.6,15,30,15z"/>
        <path d="M15,11h-5c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1C16,11.4,15.6,11,15,11z"/>
        <path d="M30,11H19c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h11c0.6,0,1-0.4,1-1C31,11.4,30.6,11,30,11z"/>
        <path d="M22,27H10c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1C23,27.4,22.6,27,22,27z"/>
        <path d="M30,27h-4c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1C31,27.4,30.6,27,30,27z"/>
        <path d="M12,23h-2c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h2c0.6,0,1-0.4,1-1C13,23.4,12.6,23,12,23z"/>
        <path d="M30,23H16c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1C31,23.4,30.6,23,30,23z"/>
    </g>,
        wp:<path className="st0" d="M20,5C11.7,5,5,11.7,5,20c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C35,11.7,28.3,5,20,5z M6.5,20
        c0-2,0.4-3.8,1.2-5.5l6.4,17.6C9.6,30,6.5,25.3,6.5,20z M20,33.5c-1.3,0-2.6-0.2-3.8-0.5l4-11.8l4.1,11.4c0,0.1,0.1,0.1,0.1,0.2
        C23.1,33.2,21.6,33.5,20,33.5z M21.9,13.7c0.8,0,1.5-0.1,1.5-0.1c0.7-0.1,0.6-1.2-0.1-1.1c0,0-2.2,0.2-3.6,0.2
        c-1.3,0-3.6-0.2-3.6-0.2c-0.7,0-0.8,1.1-0.1,1.1c0,0,0.7,0.1,1.4,0.1l2.1,5.8l-3,8.9l-4.9-14.6c0.8,0,1.5-0.1,1.5-0.1
        c0.7-0.1,0.6-1.2-0.1-1.1c0,0-2.2,0.2-3.6,0.2c-0.3,0-0.6,0-0.9,0c2.4-3.7,6.6-6.1,11.3-6.1c3.5,0,6.7,1.3,9.1,3.5
        c-0.1,0-0.1,0-0.2,0c-1.3,0-2.3,1.2-2.3,2.4c0,1.1,0.6,2.1,1.3,3.2c0.5,0.9,1.1,2.1,1.1,3.7c0,1.2-0.4,2.5-1,4.4l-1.3,4.5L21.9,13.7
        z M31.8,13.5c1.1,1.9,1.7,4.1,1.7,6.5c0,5-2.7,9.3-6.7,11.7l4.1-11.9c0.8-1.9,1-3.5,1-4.8C31.9,14.4,31.9,14,31.8,13.5z"/>,
        lerp:<path d="M35,29c-1.2,0-2.2,0.7-2.7,1.7c-4.1-1-6.8-4.1-9.3-7.8V17h-3.7c-2.9-4.5-6.2-8.6-11.4-9.7C7.6,6,6.4,5,5,5
        C3.3,5,2,6.3,2,8s1.3,3,3,3c1.2,0,2.2-0.7,2.7-1.7c4.1,1,6.8,4.1,9.3,7.9V23h3.7c2.9,4.5,6.2,8.6,11.4,9.7C32.4,34,33.6,35,35,35
        c1.7,0,3-1.3,3-3S36.7,29,35,29z M4,8c0-0.6,0.4-1,1-1s1,0.4,1,1S5.6,9,5,9S4,8.6,4,8z M19.4,21H19v-0.7V19h1.5H21v0.7V21H19.4z
        M35,33c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S35.6,33,35,33z"/>,
        parallax:<>
        <path className="st0" d="M20.1,13.4c2,0,3.6,1.6,3.6,3.6V23c0,2-1.6,3.6-3.6,3.6h-0.2c-2,0-3.6-1.6-3.6-3.6V17c0-2,1.6-3.6,3.6-3.6H20.1
            M20.1,11.4h-0.2c-3.1,0-5.6,2.5-5.6,5.6V23c0,3.1,2.5,5.6,5.6,5.6h0.2c3.1,0,5.6-2.5,5.6-5.6V17C25.7,13.9,23.2,11.4,20.1,11.4
            L20.1,11.4z"/>
        <path className="st0" d="M20,15c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2C21,15.4,20.6,15,20,15L20,15z"/>
        <g>
            <path className="st0" d="M20,30c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S20.6,30,20,30L20,30z"/>
            <path className="st0" d="M20,33c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S20.6,33,20,33L20,33z"/>
        </g>
        <g>
            <path className="st0" d="M20,5c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S20.6,5,20,5L20,5z"/>
            <path className="st0" d="M20,8c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S20.6,8,20,8L20,8z"/>
        </g>,
        
</>

    }

    return <div className={outer+' p-1 inline-block rounded-lg mb-4'}>
    <svg className={inner+' w-[50px] h-[50px] flex items-center'} x="0px" y="0px" viewBox="0 0 40 40" >
        {icons[name]}
    </svg>
</div>
}

export default Icon